import Component from '@glimmer/component';

import { action } from '@ember/object';
import { service } from '@ember/service';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

export default class extends Component {
  @service fieldHeightOverlays;
  @action didInsertContainer(el) {
    this.fieldHeightOverlays.containerEl = el;
  }

  <template>
    <div class="c-field-height__overlay-container"
      {{didInsert this.didInsertContainer}}
      ...attributes
    >{{yield}}</div>
  </template>
}
